import React from "react";
import InstructorCard from "@/components/common/card/InstructorCard";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import { Empty } from "antd";

export default function Instructor({ course }) {
  return (
    <div className="instructor_section">
      <h2 className="title">কোর্স ইনস্ট্রাক্টর</h2>
      <div className="instructor_card_section">
        <div className="instructor_card_slider">
          {course?.course_instructors?.length > 0 ? (
            <Swiper
              modules={[Navigation]}
              slidesPerView={1}
              spaceBetween={20}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              loop={true}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              breakpoints={{
                768: { slidesPerView: 1 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 2 },
              }}
            >
              {course?.course_instructors?.map((course, index) => (
                <SwiperSlide key={index}>
                  <InstructorCard instructor={course?.teacher} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Empty />
          )}
        </div>
        {course?.course_instructors?.length > 0 && (
          <div className="instructor_arrow">
            <div className="swiper-button-prev">
              <button className="arrow-icon">
                <IoChevronBackOutline />
              </button>
            </div>
            <div className="swiper-button-next">
              <button className="arrow-icon">
                <IoChevronForwardOutline />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
